import gql from "graphql-tag";
export const UPDATE_DEPARTEMENT = gql`
  mutation departement_prs($id: Int, $label: String, $id_directeur: Int) {
    updateDepartement(id: $id, label: $label, id_directeur: $id_directeur)
  }
`;
